/**
 * `1825` — *duplicate {group, groupId}*. Static recipe `152` maps to `47 → 1825`, confirmed by
 * monday's own catalogue (`overrideStaticRecipeId: 152`), which retires the `ez.a.duplicate_group`
 * guess in the first draft of `specs/M6-A3` §13.
 *
 * Board-level: it runs from a recurrence, where the event carries no item.
 */
import { z } from 'zod';
import { defineAction } from '../block.js';
export const duplicateGroupParams = z.object({ groupId: z.string().min(1) });
export const duplicateGroupAction = defineAction({
    id: '1825',
    kind: 'action',
    app: 'monday',
    sentencePartial: 'duplicate {group, groupId}',
    paramsSchema: duplicateGroupParams,
    executable: true,
    references: (params) => [{ kind: 'group', id: params.groupId }],
    async execute(context, params) {
        const created = await context.services.duplicateGroup({
            boardId: context.boardId,
            groupId: params.groupId,
            withItems: true,
        });
        return { groupId: created.groupId, sourceGroupId: params.groupId };
    },
});
//# sourceMappingURL=1825.js.map